export const environment = {
  production: false,
  TOKEN_API: 'https://api.dev2.token.ck1lab.net',
  KIDS_CLIENT_API: 'https://api.dev.kids.ck1lab.net',
};
